"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader } from "lucide-react";
function InquiryForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center space-y-4 rounded-lg border border-primary/20 bg-primary/5 p-8 text-center">
        <div className="flex size-12 items-center justify-center rounded-lg bg-primary/20 text-primary">
          <svg className="size-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p className="text-lg font-medium text-foreground">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4 border-primary/50 text-primary hover:bg-primary/10 hover:text-primary">
          Request Site Survey
        </Button>
      </div>;
  }
  const inputStyles = "border-0 border-b border-border rounded-none bg-transparent px-0 shadow-none focus-visible:ring-0 focus-visible:border-primary focus-visible:border-b-2 transition-colors text-foreground placeholder:text-muted-foreground/50";
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <FormField control={control} name="name" rules={{
      required: "Identification is required",
      minLength: {
        value: 2,
        message: "Minimum 2 characters required"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-xs tracking-widest text-muted-foreground uppercase">
              Name
            </FormLabel>
            <FormControl>
              <Input placeholder="Enter your name" className={inputStyles} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "Email address is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email format"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-xs tracking-widest text-muted-foreground uppercase">
              Email Address
            </FormLabel>
            <FormControl>
              <Input type="email" placeholder="your@email.com" className={inputStyles} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Message is required",
      minLength: {
        value: 10,
        message: "Message must be at least 10 characters"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-xs tracking-widest text-muted-foreground uppercase">
              Message
            </FormLabel>
            <FormControl>
              <Textarea placeholder="Enter your message here..." className={`min-h-[120px] resize-none ${inputStyles}`} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="rounded-md border border-destructive/50 bg-destructive/10 p-4">
          <p className="text-sm text-destructive">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-14 text-base font-bold tracking-wider uppercase bg-primary text-primary-foreground hover:bg-primary/90 transition-all">
        {isSubmitting ? <>
            <Loader className="mr-2 size-5 animate-spin" />
            Transmitting...
          </> : "Submit Transmission"}
      </Button>
    </Form>;
}
export default function GetStarted() {
  return <section id="get-started" className="bg-background">
      {}
      <div className="dark bg-gradient-to-br from-zinc-950 to-zinc-900 py-24 md:py-32 relative overflow-hidden">
        {}
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" />
        
        <div className="container mx-auto px-6 max-w-7xl relative z-10">
          <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
            
            {}
            <div className="flex flex-col justify-center space-y-8 lg:sticky lg:top-32">
              <div className="space-y-4">
                <div className="inline-flex items-center space-x-2 text-primary">
                  <span className="size-2 bg-primary rounded-lg animate-pulse" />
                  <span className="text-sm font-mono tracking-widest uppercase">System Ready</span>
                </div>
                <h2 className="font-default font-bold text-4xl md:text-5xl lg:text-[48px] leading-tight text-foreground uppercase tracking-tight">
                  Initiate<br />Connection
                </h2>
              </div>
              <p className="text-lg text-muted-foreground max-w-md leading-relaxed">Connect with us and our multi-carrier network. Enter your details below to request a site survey or initiate technical support with our field team.</p>
            </div>

            {}
            <div className="bg-zinc-900/50 border border-white/5 backdrop-blur-sm p-8 md:p-10 rounded-xl shadow-2xl">
              <FormProvider formId="inquiry-interface-form" sectionName="Get Started" defaultValues={{
              name: "",
              email: "",
              message: ""
            }} submitText="Submit Transmission" successMessage="Service scheduled successfully.">
                <InquiryForm />
              </FormProvider>
            </div>

          </div>
        </div>
      </div>
    </section>;
}